import 'dayjs/locale/zh-cn'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import { isValidDate } from './validator'

dayjs.locale('zh-cn')
dayjs.extend(relativeTime)
dayjs.extend(weekOfYear)

export { dayjs }

export function fromNow (date) {
  return isValidDate(date) ? dayjs(date).fromNow() : ''
}

export function format (date, format) {
  return isValidDate(date) ? dayjs(date).format(format) : ''
}

export function formatDate (date) {
  return format(date, 'YYYY-MM-DD')
}

export function formatTime (date) {
  return format(date, 'YYYY-MM-DD HH:mm:ss')
}

export function diff (date1, date2, unit = 'd', floor = false) {
  return dayjs(date1).diff(dayjs(date2), unit, floor)
}

export function add (date, num = 0, unit = 'M') {
  return dayjs(date).add(num, unit)
}

export function getWeekOfYear (date) {
  return dayjs(date).week()
}
